var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileoverlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "desktop_sign_in_mobile",
    "data-name": "desktop sign in mobile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 932,
    viewBox: "0 0 430 932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 430,
    height: 932
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    width: 76,
    height: 50,
    rx: 10,
    transform: "translate(16 26)",
    fill: "#bebebe"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2167",
    "data-name": "Rectangle 2167",
    width: 200,
    height: 25,
    rx: 10,
    transform: "translate(15 148)",
    fill: "#bebebe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    width: 200,
    height: 25,
    rx: 10,
    transform: "translate(15 214)",
    fill: "#bebebe"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2176",
    "data-name": "Rectangle 2176",
    width: 200,
    height: 25,
    rx: 10,
    transform: "translate(15 277)",
    fill: "#bebebe"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    width: 200,
    height: 25,
    rx: 10,
    transform: "translate(15 343)",
    fill: "#bebebe"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2178",
    "data-name": "Rectangle 2178",
    width: 200,
    height: 25,
    rx: 10,
    transform: "translate(15 409)",
    fill: "#bebebe"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2171",
    "data-name": "Rectangle 2171",
    width: 50,
    height: 25,
    rx: 10,
    transform: "translate(23 746)",
    fill: "#a2a2a2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2172",
    "data-name": "Rectangle 2172",
    width: 50,
    height: 25,
    rx: 10,
    transform: "translate(23 791)",
    fill: "#a2a2a2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2173",
    "data-name": "Rectangle 2173",
    width: 50,
    height: 46,
    rx: 10,
    transform: "translate(23 857)",
    fill: "#a2a2a2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2166",
    "data-name": "Rectangle 2166",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(363 26)",
    fill: "#a2a2a2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    d: "M25,0H338a0,0,0,0,1,0,0V841a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V25A25,25,0,0,1,25,0Z",
    transform: "translate(92 91)",
    fill: "#bebebe"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2179",
    "data-name": "Rectangle 2179",
    width: 430,
    height: 932,
    opacity: 0.801
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileoverlay);
export default __webpack_public_path__ + "static/media/mobileoverlay.3292ebdbc88a82a880821d57e2d8ed3c.svg";
export { ForwardRef as ReactComponent };